import type { WallShape } from '@walls/store';
import { hexToRgba } from '../utils/color';
import { getRectangleAttributes } from '../utils/shapeAttributes';
import { drawSelectionBorder } from './drawSelectionBorder';

export function drawCircle(
  context: CanvasRenderingContext2D,
  shape: WallShape,
  zoom: number,
  selected: boolean
) {
  const attributes = getRectangleAttributes(shape);
  const kappa = 0.5522848;
  const ox = (attributes.width / 2) * kappa;
  const oy = (attributes.height / 2) * kappa;
  const xe = attributes.x + attributes.width;
  const ye = attributes.y + attributes.height;
  const xm = attributes.x + attributes.width / 2;
  const ym = attributes.y + attributes.height / 2;

  context.setLineDash([0]);
  context.beginPath();
  context.moveTo(attributes.x, ym);
  context.bezierCurveTo(attributes.x, ym - oy, xm - ox, attributes.y, xm, attributes.y);
  context.bezierCurveTo(xm + ox, attributes.y, xe, ym - oy, xe, ym);
  context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
  context.bezierCurveTo(xm - ox, ye, attributes.x, ym + oy, attributes.x, ym);

  if (attributes.fillColor) {
    context.fillStyle = hexToRgba(attributes.fillColor, attributes.fillOpacity);
    context.fill();
  }

  context.lineWidth = attributes.lineThickness;
  context.strokeStyle = hexToRgba(attributes.lineColor, attributes.lineOpacity);
  context.stroke();

  if (selected) {
    drawSelectionBorder(context, attributes, zoom);
  }
}
